import { render, staticRenderFns } from "./ProjectStaffings.vue?vue&type=template&id=c624bd70&scoped=true&"
import script from "./ProjectStaffings.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStaffings.vue?vue&type=style&index=0&id=c624bd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624bd70",
  null
  
)

export default component.exports